import { Routes } from '@angular/router';

export const openBindersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./open-binders.page').then((m) => m.OpenBindersPage),
  },
];
